import { uuidModule } from "@/modules/uuid";
import {
  AudioRecordingModelData,
  AudioRecordingSyncUpdateValue,
} from "@/store/audio-recordings/types";
import { BaseSyncOperation } from "@/store/sync/operations/BaseSyncOperation";
import { SyncErrorHandlingType } from "@/store/sync/operations/errors/SyncError";
import { ITrashAudioRecordingOperation } from "@/store/sync/operations/types";
import { OptimisticSyncUpdate, SyncCustomErrorData, SyncOperationKind } from "@/store/sync/types";

export class TrashAudioRecordingOperation extends BaseSyncOperation<ITrashAudioRecordingOperation> {
  get operationKind(): SyncOperationKind {
    return "TRASH_AUDIO_RECORDING";
  }

  async generateOptimisticUpdates(): Promise<OptimisticSyncUpdate<AudioRecordingModelData>[]> {
    const recording = this.store.audioRecordings.get(this.payload.id);
    if (!recording) return [];

    const value: AudioRecordingSyncUpdateValue = {
      model_id: this.payload.id,
      model_kind: "AUDIO_RECORDING",
      model_version: recording.modelVersion,
      model_data: {
        ...recording.modelData,
        trashed_at: this.committedAt,
      },
      model_scopes: recording.modelScopes,
    };

    const optimisticUpdate: OptimisticSyncUpdate<AudioRecordingModelData> = {
      optimistic_update_id: uuidModule.generate(),
      locally_committed_at: this.committedAt,
      kind: "UPSERTED",
      value,
    };

    return [optimisticUpdate];
  }

  async triggerRecompute(): Promise<void> {
    await this.store.audioRecordings.recompute(this.payload.id);
  }

  handleInvalidError(_errorData: SyncCustomErrorData) {
    this.ignoreError();
  }

  handlePermissionDeniedError(_errorData: SyncCustomErrorData) {
    this.ignoreError();
  }

  handleUnknownError(_errorData: SyncCustomErrorData) {
    this.ignoreError(SyncErrorHandlingType.RetryWithLimit);
  }
}
